import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { dataDelivery } from './data-delivery';
import { advanced } from './advanced';
import { rainAlarm } from './alarms';
import { rainInfo } from './rain-info';
import { rainSensor } from './rain-sensor';
import { dialogActions } from './dialog-actions';
import { RainAlertLocationCardState } from './models';
import { Config } from 'app/shared/services/config';

/**
 * Rain form configuration
 */
export const rainFormState = (state: RainAlertLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'rain-location-config',
                title: 'Rain Location Configuration',
            },
            sections: [
                basicInfo(state),
                rainInfo(state),
                rainSensor(state),
                dataDelivery(state),
                rainAlarm(state),
                advanced(state),
                dialogActions(state),
            ],
        },
        pristine: true,
        valid: false,
        submitted: false,
    };
}
